import { BPS_DENOM, NANO } from '@gong/curve-math';

export function unixNow(): number {
  return Math.floor(Date.now() / 1000);
}

export function parseDecimal(input: string, decimals = 9): bigint {
  const trimmed = input.trim().replace(',', '.');
  if (!trimmed || trimmed === '.') {
    return 0n;
  }
  if (!/^\d+(\.\d*)?$/.test(trimmed)) {
    throw new Error('invalid amount');
  }
  const [whole = '0', frac = ''] = trimmed.split('.');
  const fracPadded = (frac + '0'.repeat(decimals)).slice(0, decimals);
  return BigInt(whole) * 10n ** BigInt(decimals) + BigInt(fracPadded);
}

export function parseTon(input: string): bigint {
  return parseDecimal(input, 9);
}

export function formatUnits(amount: bigint, decimals = 9, maxFrac = 4): string {
  const neg = amount < 0n;
  const abs = neg ? -amount : amount;
  const base = 10n ** BigInt(decimals);
  const whole = abs / base;
  let frac = (abs % base).toString().padStart(decimals, '0');
  frac = frac.replace(/0+$/, '').slice(0, maxFrac);
  const sign = neg ? '-' : '';
  return frac.length > 0 ? `${sign}${whole}.${frac}` : `${sign}${whole}`;
}

export function formatTon(amount: bigint, maxFrac = 4): string {
  return `${formatUnits(amount, 9, maxFrac)} TON`;
}

export function formatJettons(amount: bigint, ticker = 'TOKEN', maxFrac = 2): string {
  return `${formatUnits(amount, 9, maxFrac)} ${ticker}`;
}

export function formatAddress(value: string, left = 6, right = 4): string {
  if (value.length <= left + right + 1) {
    return value;
  }
  return `${value.slice(0, left)}…${value.slice(-right)}`;
}

export function applySlippage(amount: bigint, slippageBps: bigint): bigint {
  if (amount <= 0n) {
    return 0n;
  }
  return (amount * (BPS_DENOM - slippageBps)) / BPS_DENOM;
}

export function progressBps(current: bigint, total: bigint): number {
  if (total <= 0n) {
    return 0;
  }
  const bps = Number((current * 10_000n) / total);
  return Math.max(0, Math.min(10_000, bps));
}

export const NANO_DISPLAY = NANO;
